export default __webpack_public_path__ + "static/index_bg_3_tn-2cb7f4c7efd257e83d20915bc27483b9.png";